import WebsiteStore from "../../WebsiteStore";

export const selectUserData = (state:WebsiteStore) => state.get('userData')